import {Component, OnDestroy, OnInit} from '@angular/core';
import {ReactiveFormsModule, UntypedFormControl} from '@angular/forms';
import {Subject} from 'rxjs';
import {takeUntil} from 'rxjs/operators';
import {AuthService} from '../services/auth.service';
import {DataService} from '../services/data.service';
import {EllipsisPipe} from '../shared/pipes/ellipsis.pipe';
import {Budget} from '../interfaces';
import {WorkersSummaryListComponent} from '../workers-summary-list/workers-summary-list.component';
import {MatFormField, MatInput} from '@angular/material/input';
import {MatAutocomplete, MatAutocompleteTrigger, MatOption} from '@angular/material/autocomplete';
import {ProjectNrPipe} from '../shared/pipes/project-nr.pipe';



@Component({
    selector: 'app-workers-summary',
    templateUrl: './workers-summary.component.html',
    imports: [
        ReactiveFormsModule,
        WorkersSummaryListComponent,
        MatFormField,
        MatFormField,
        MatAutocomplete,
        MatOption,
        MatInput,
        MatAutocompleteTrigger,
        MatInput,
        EllipsisPipe,
        ProjectNrPipe
    ],
    styleUrls: ['./workers-summary.component.scss']
})
export class WorkersSummaryComponent implements OnInit, OnDestroy {

    selectProject: UntypedFormControl;

    timeInterval: UntypedFormControl;

    private unsubscribe$ = new Subject();

    public allProjects: Partial<Budget>[] = [];
    public options: Partial<Budget>[] = [];

    public canChange = false;


    constructor(private dataService: DataService,
                private authService: AuthService,
                private ellipsisPipe: EllipsisPipe
    ) {
    }

    ngOnInit() {
        this.selectProject = new UntypedFormControl();
        this.timeInterval = new UntypedFormControl(10000);

        this.dataService.getProjectList()
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(projects => {
                this.allProjects = projects as any;
                this.options = this.filterOptions(this.allProjects, undefined);
            });

        this.selectProject.valueChanges
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe(value => {

                if (typeof value === 'string' || typeof (value) === 'string') {
                    console.log('filtering', value);
                    this.options = this.filterOptions(this.allProjects, value);

                } else {
                    console.log('skipped bullet', value);
                }
            });

        this.authService.userHasPermission('app.workers.edit')
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((val) => {
                this.canChange = val;
            });
    }


    public selectedProject($event) {
        console.log('selected project:', $event);

        if (!$event.option.value.id) {
            return;
        }

        this.dataService.selectForWorkersList($event.option.value.id);

    }

    private filterOptions(allProjects: Partial<Budget>[], value: string): Partial<Budget>[] {
        console.log('filter options: ', value, this.selectProject.value, allProjects.length);
        return allProjects.filter(p => {
            return !value ||
                (p.project && p.project.projectNr.includes(value)) ||
                (p.budgetNr && p.budgetNr.toUpperCase().includes(value.toUpperCase()));
        });
    }

    public budgetDisplayFn = (budget: Budget): string => {
        if (budget) {
            let ret = budget.budgetNr;
            if (budget.project) {
                ret = (budget.project.internal ? 'i' : '') + budget.project.projectNr + '-' + ret;
            }
            let cn;
            if (budget.company?.companyName) {
                cn = this.ellipsisPipe.transform(budget.company.companyName, 20);
                ret = cn + ' ' + ret;
            }
            return ret;
        } else {
            return null;
        }
    }

    public ngOnDestroy() {
        this.unsubscribe$.next(null);
        this.unsubscribe$.complete();

    }
}
